export default __webpack_public_path__ + "static/media/exclude.bb9dcfe0.svg";